const METRICS_CANVAS = "OffscreenCanvas" in self ? new OffscreenCanvas(100, 100) : null;
const METRICS_CONTEXT = METRICS_CANVAS ? METRICS_CANVAS.getContext("2d") : null;
export class ScriptTextMetrics {
    static measureText(text, fontSize) {
        if (typeof text !== "string")
            return undefined;
        if (!METRICS_CONTEXT) {
            // fallback
            // ToDo: add more metrics properties
            return {
                width: Math.ceil(fontSize * 0.8 * text.length)
            };
        }
        METRICS_CONTEXT.font = `normal ${fontSize}px Arial`;
        return METRICS_CONTEXT.measureText(text);
    }
}
